<template>
    <div v-if="inventarisBarang">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 v-if="isApproval" class="modal-title">Approve Inventaris Gudang</h5>
                <h5 v-else class="modal-title">{{ inventarisBarang.id ? 'Informasi' : 'Konfirmasi' }} Inventaris Gudang</h5>
            </b-card-header>
            <b-card-body>
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Nama Barang</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ inventarisBarang.name }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal Pembelian</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(inventarisBarang.tanggal_pembelian) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Jumlah</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(inventarisBarang.jumlah) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Harga</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(inventarisBarang.harga) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Total</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(inventarisBarang.total) }}</th>
                        </tr>
                        <template v-if="inventarisBarang.deleted_at && (inventarisBarang.approved_at || isApproval)">
                            <tr>
                                <th class="fit-column">Status</th>
                                <td class="fit-column">:</td>
                                <th class="text-primary">{{ inventarisBarang.status }}</th>
                            </tr>
                            <tr v-if="inventarisBarang.status == 'terjual'">
                                <th class="fit-column">Harga Terjual</th>
                                <td class="fit-column">:</td>
                                <th class="text-primary">{{ formatNumber(inventarisBarang.harga_keluar) }}</th>
                            </tr>
                        </template>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('koreksi')" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="isLoading = true; $emit('ok')" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi && !isApproval" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isApproval" @click="save" type="button" class="btn btn-primary mr-2">Approve</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "inventaris-barang-viewer",

    props: {
        isKonfirmasi: {
            type: Boolean,
            default: false,
        },

        isApproval: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
    },

    data() {
        return {
            inventarisBarang: null,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initInventarisBarang();
        }
    },

    computed: {
        id() {
            return this.inventarisBarang.inventaris_barang_id ? this.inventarisBarang.inventaris_barang_id : this.inventarisBarang.id;
        },
    },

    watch: {
        value() {
            this.initInventarisBarang();
        }
    },

    methods: {
        initInventarisBarang() {
            let self = this;

            self.inventarisBarang = Object.assign({}, self.isApproval && self.value.inventaris_barang_update ? self.value.inventaris_barang_update : self.value);
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/inventaris-barangs/print/'+self.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        save() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    this._save();
                }
            });
        },

        _save() {
            let self = this;

            self.isLoading = true;

            let api = '/api/inventaris-barangs/'+self.id+'/approve';

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.$Progress.finish();
                self.isLoading = false;
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
